import http from '../api/http'
import config from '../api/config'

/**防抖
 * 参数:
 * 返回值:
 */

 export const debounce=function(fn,wait) {
  let timer;
  return function() {
     
    let context = this; // 注意 this 指向
    let args = arguments; // arguments中存着e
       
    if (timer) clearTimeout(timer);
      
    timer = setTimeout(() => {
        
        fn.apply(context,args)
      
    }, wait)
  }
  
}

/**节流
 * 参数:
 * 返回值:
 */

 export const Throttle=function(fn,delay) {
  let pre=Date.now()
  return function (){
     let that=this
     let args=arguments
     let now=Date.now()
     if(now - pre >= delay){
         fn.apply(that,args)
         pre=Date.now()
     }
      
  }
 
}

/**获取仓库产品信息，以及产品所绑定的模版的信息
 * 参数:{groupId,productId}
 * 返回值:{groupInfo,template},
 */

export const  getGruopAndTempInfo =async function(obj) {
  let groupId=obj.groupId
  let productId=obj.groupId

  const res1 = await http({
      url: config.GET_STOREITEM_BY_GROUPID,
      method: 'get',
      data:{
        groupId:groupId,
      }
  })

  const res2=await http({
    url: config.GET_PRODUCT_ID,
    method: 'get',
    data:{
      productId:res1.data.data.productId
    }
  })

  
  let groupInfo=res1.data.data
  let storeItems=groupInfo.storeItems
  let temp=res2.data.data
  console.log('groupInfo',groupInfo);
  console.log('temp',temp);
  let variations=temp.variations
  for(let i=0;i<variations.length;i++ ){
    let item=storeItems.find(p => p.cusCode == variations[i].cusCode)
    variations[i].stock=item ? item.storeNum : variations[i].stock
  }

  

  return obj={
    groupInfo:groupInfo,
    template:temp
  }



  

  
  
}



/**判断订单是否为带有敏感货的订单
 * 参数:每个订单的items
 * 返回值:true:是,false:不是,
 */

 export const  JudegeSensitive= function (list) {
  let type=false
  for(let i=0;i<list.length;i++){
    if(list[i].storeItem.sensitive){
      type=true
    }
  }
  return type

}


/**判断订单是否绑定了仓库产品,
 * 参数:每个订单的items
 * 返回值:0:已绑定,1未绑定,2,订单内有不同仓库的产品
 */

export const JudegeBindStore = function (list) {
  let type=0
  let storeIds=[]
  for(let i=0;i<list.length;i++){
    let storeItem=list[i].storeItem
    if(storeItem == null || storeItem == []){
      type=1
    }else{
      if(!storeIds.includes(storeItem.storeId)){
        storeIds.push(storeItem.storeId)
      }
    }
  }
  type=storeIds.length > 1 ? 2 : type
  return type

}

// 生成指定长度的不重复随机数组
export const randomNumArr = function (count = 10) {
    var arr = new Array; //原数组 
    //给原数组arr赋值 
    for (var i = 0; i < count; i++) {
      arr[i] = i;
    }
    var d1 = new Date().getTime();
    arr.sort(function () {
      return 0.5 - Math.random();
    });
  
    return arr
  }

 // 生成从minNum到maxNum的随机数
export const randomNum = function (minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10)
      break
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      break
    default:
      return 0
      break
  }
} 

//格式化当前时间
export const dateFormat = (fmt = 'yyyyMMddhhmmssS', date = new Date()) => {
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    
    let ms = o['S'].toString()
    console.log(o)
    console.log(ms)
    if (ms.length === 1) {
      o['S'] = '00' + ms
    } else if (ms.length === 2) {
      o['S'] = '0' + ms
    }

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }


// 判断设备类型
export const getDeviceType = () => {
    var ua = navigator.userAgent.toLowerCase()
    var bIsIpad = ua.match(/ipad/i) === 'ipad'
    var bIsIphoneOs = ua.match(/iphone os/i) === 'iphone os'
    var bIsMidp = ua.match(/midp/i) === 'midp'
    var bIsUc7 = ua.match(/rv:1.2.3.4/i) === 'rv:1.2.3.4'
    var bIsUc = ua.match(/ucweb/i) === 'ucweb'
    var bIsAndroid = ua.match(/android/i) === 'android'
    var bIsCE = ua.match(/windows ce/i) === 'windows ce'
    var bIsWM = ua.match(/windows mobile/i) === 'windows mobile'
    var bIsWX = ua.match(/MicroMessenger/i) === 'micromessenger'
  
    return (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsWX) ? 'mobile' : 'PC'
}


//设置时间间隔限制
export const timeSpanNoValid = (key, timespan = 1000) => {
    if (!key) {
      return false
    }
    let nowTime = new Date().getTime();
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, nowTime);
    }
    const lastSendTime = sessionStorage.getItem(key);
    if (nowTime - sessionStorage.getItem(key) < timespan) {//毫秒
      console.log("====timeSpanNoValid.true", key, nowTime - sessionStorage.getItem(key));
      return true;
    }
    sessionStorage.setItem(key, nowTime);
    console.log("====timeSpanNoValid.false", key,  nowTime);
    return false
  }